import React, { useContext, useRef, useState } from 'react';
import Cross from '../../../../../Assets/Modals/closeIcon.svg';
import { useDispatch } from 'react-redux';
import { useOutsideClickHandler } from '../../../../../Hooks/useOutsideClick';
import { closeModal } from '../../../../../Features/inventoryManagementSlice';
import AddBlue from '../../../../../Assets/Modals/AddBlue.svg';
import { toCamelCase } from '../../../../../lib/utils/utils';
import { InventoryAddProductFormContext } from '../../../../../Context/InventoryAddProductFormContext';
import { showToast } from '../../../../../Components/Toaster/Toaster';

function SizeVariant() {
    const dispatch = useDispatch();

    const containerRef = useRef(null);

    useOutsideClickHandler(containerRef, () => {
        dispatch(closeModal());
    });

    const { sizeVariants, setSizeVariants } = useContext(InventoryAddProductFormContext);

    const handleCloseModal = () => {
        dispatch(closeModal());
    }

    const defaultOptionList = [
        {
            id: 'optionValue1',
            value: ''
        }
    ]

    const [optionList, setOptionList] = useState(defaultOptionList);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const character = e.nativeEvent.data;
        
        if(character === ',') {
            showToast('Invalid input', 'warning');
        }
        else {
            setOptionList(prevOptions => 
                prevOptions.map(option => 
                    option.id === name ? { ...option, value } : option
                )
            );
        }
    }

    // helper function to reindex ids
    const reindexOptions = (options) => {
        return options.map((option, index) => ({
            ...option,
            id: `optionValue${index + 1}`,
        }));
    };

    // add option
    const handleAddOption = () => {
        setOptionList(prevOptions =>
            reindexOptions([
                ...prevOptions,
                { id: "", value: "" } 
            ])
        );
    };

    // remove option
    const handleRemoveOption = (optionId) => {
        setOptionList(prevOptions =>
            reindexOptions(prevOptions.filter(option => option.id !== optionId))
        );
    };

    const handleSave = () => {
        let result = [];
        let allValid = true;

        for(const option of optionList) {
            if(!option.value.trim()) {
                showToast('Please add a size value.', 'warning');
                allValid = false;
            }
            else {
                let sizeObject = {
                    size: option.value,
                    id: toCamelCase(option.value),
                    mrp: '',
                    sellingPrice: '',
                    primary: false
                }

                result.push(sizeObject);
            }
        }

        if(allValid) {
            setSizeVariants([ ...sizeVariants, ...result ]);
            dispatch(closeModal());
        }
    }

    return (
        <div ref={containerRef} className='w-[44%] h-fit p-6 pt-[18px] flex flex-col gap-6 rounded-xl bg-[#FFFFFF] shadow-[0px_0px_12px_0px_#0000003D]'>
            <div className="flex flex-col gap-4">
                <div className="flex items-center justify-between">
                    <p className='font-semibold text-2xl text-[#121212]'>Add Size</p>

                    <button onClick={handleCloseModal} className="outline-none w-11 h-11 flex items-center justify-center">
                        <img src={Cross} alt="" />
                    </button>
                </div>

                <div className="flex flex-col gap-3 max-h-96 overflow-y-scroll">
                    {optionList.map(option => {
                        return (
                            <div key={option.id} className='flex flex-col gap-2'>
                                <div className="flex items-center justify-between">
                                    <label
                                        className='select-none cursor-pointer w-fit font-medium text-base text-[#121212]'
                                        htmlFor={option.id}
                                    >
                                        Input value<span className="text-[#DC2626]">*</span>
                                    </label>

                                    {/* If you have errorText, conditionally render here */}
                                    {/* <p className='text-[14px] leading-5 text-[#DC2626] select-none'>{errorText}</p> */}
                                    <button onClick={() => handleRemoveOption(option.id)} className='text-[14px] leading-5 text-[#DC2626] select-none'>Remove</button>
                                </div>

                                <input
                                    className='outline-none px-3 py-4 bg-[#F5F5F5] border border-[#EAEAEA] rounded-[9px] font-normal text-base text-[#121212] focus:border-primaryColor'
                                    type="text"
                                    id={option.id}
                                    name={option.id}
                                    placeholder="enter size"
                                    value={option.value}
                                    onChange={handleChange}
                                />
                            </div>
                        );
                    })}

                    <button onClick={handleAddOption} className='w-fit flex items-center'>
                        <div className="w-6 h-6 flex items-center justify-center">
                            <img src={AddBlue} alt="" />
                        </div>

                        <p className='font-medium text-base text-[#1055EB]'>Add option</p>
                    </button>
                </div>
            </div>
            
            <button onClick={handleSave} className='px-4 py-2 rounded bg-primaryColor hover:bg-primaryAccent font-semibold text-base text-buttonText'>Save</button>
        </div>
    );
}

export default SizeVariant;
